const install = (Vue, vm) => {
	
	uni.$u.http.setConfig((config) => {
	    config.baseURL = vm.$baseUrl;
		config.timeout = 60000;
	    return config;
	})
	
	let login = (params = {}) => vm.$u.http.get('mobile/system/login', { params });	// 登录
	
	vm.$u.api = {
		login
	};
}

export default { install }